const toastText = {
  success: {
    TITLE: 'Swap for Credit',
    SUBTITLE: 'You’re all set. An email confirmation will be sent when swap is completed.',
  },
};

export default toastText;
